import { ReviewContent } from './types';

export const TRUSTPILOT_REVIEW_DATA = {
  numberOfReviews: 5775,
  score: 4.7,
} as const;

export const TRUSTPILOT_REVIEWS: ReviewContent[] = [
  {
    title: 'Easy to work with',
    href: 'https://www.trustpilot.com/reviews/63f271029b64b1bdaf5c5fe2?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Akhil',
    text: 'I was looking for a term life policy to cover my family in case the worst happened to me. The PolicyGenius site was easy to use, I was presented with a range of quotes within hours and the integration with the policy provider I ended up going with was seamless; would recommend!',
    createdAt: 'February 18th',
  },
  {
    title: 'Smooth Process with Expert Guidance',
    href: 'https://www.trustpilot.com/reviews/67a69221ca025f3f227053a0?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Rohan',
    text: 'I recently used Policygenius to find term life insurance and was thoroughly impressed. The process was straightforward, and the comparison tools helped me choose the best policy. Their advisors are knowledgeable and provided clear, helpful guidance every step of the way. Highly recommend!',
    createdAt: 'February 4th',
  },
  {
    title: 'Knowledgeable, Responsive and Courteous',
    href: 'https://www.trustpilot.com/reviews/625615a32b3c3c43cfd11203?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Mark',
    text: 'The team quickly assessed my needs, they were knowledgeable of the products, and articulated a recommendation that was the best fit. The application process was simple, and they were available at each stage of the process to ensure the application was moving along. A great experience!',
    createdAt: 'April 17th',
  },
  {
    title: 'Working with Courtney Roy was so…',
    href: 'https://www.trustpilot.com/reviews/688287fc7acb33d26aa7d33f?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Geoff Garber',
    text: 'Working with Courtney Roy was so refreshing.  No sales pressure, relatable, funny, and genuine.  This man deserves a raise and promotion.  I can now sleep better at night knowing my family is taken care of with a solid life insurance policy.',
    createdAt: 'July 24th',
  },
  {
    title: 'Policygenius made the process easy!',
    href: 'https://www.trustpilot.com/reviews/63f271029b64b1bdaf5c5fe3?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Kimberly',
    text: "Policygenius made the process easy to navigate. The representatives were helpful and attentive to my questions. They were persistent in trying to help me find the best insurance for my current life goals. Once they connected me with insurance agents, the application process was relatively quick and, again, easy to navigate. I'd recommend them to anyone!",
    createdAt: 'February 2nd',
  },
  {
    title: 'This was an easy and simple process',
    href: 'https://www.trustpilot.com/reviews/63f271029b64b1bdaf5c5fe4?utm_medium=trustbox&utm_source=Slider',
    displayName: 'Karen',
    text: 'This was an easy and simple process. It was not stressful at all. All of my questions were answered. I felt seen and listened to throughout the process. If you are on the fence don’t be you will not regret the decision to use this service.',
    createdAt: 'April 13th',
  },
];

export const CAROUSEL_GAP_PX = 24;
